import * as React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import {Fragment} from "react";

import './IconTooltip.scss' ;

const ItemTooltip = ( props ) =>
{
    const defaultOffset = props.offset === undefined ? [0,8] : props.offset ;

    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible
    } = usePopperTooltip( { placement: props.placement === undefined ? 'top' : props.placement, followCursor: true, offset: defaultOffset }, { });

    return (
        <Fragment>
            <span ref={setTriggerRef} style={{...props.style, cursor: 'pointer', color: props.color}} >
                { props.children }
            </span>

            {visible && (
                <div
                    ref={setTooltipRef}
                    {...getTooltipProps({ className: 'tooltip-container' })}
                >
                    {props.text}
                    <div {...getArrowProps({ className: 'tooltip-arrow' })} />
                </div>
            )}
        </Fragment>
    );
}

export default ItemTooltip ;
